var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading"},[_c('a-layout-content',{style:({ margin: '24px 16px' })},[_c('a-row',{attrs:{"gutter":16}},[_c('a-col',{attrs:{"span":24}},[_c('a-alert',{attrs:{"message":_vm.title,"description":_vm.message,"type":"error","show-icon":""}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }